// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__IgMQ1","title":"Images45_title__3fufV","images":"Images45_images__1V4-w"};